import { Loan } from '../../generated/graphql';
import { AmountTable, AmountTableProps } from './Table';

export interface LoansTableContainerProps
  extends Pick<
    AmountTableProps,
    'title' | 'className' | 'hideOnEmpty' | 'isLoading' | 'tableRowsContainerClassName' | 'tableTitleClassName'
  > {
  onItemClicked?: (a: { loan: Loan }) => void;
  isLoading?: boolean;
  loanArray?: Loan[];
  title?: string;
  children?: (p: { loan: Loan }) => React.ReactNode;
}

export const LoansTableContainer = ({ onItemClicked, loanArray, children, ...props }: LoansTableContainerProps) => {
  return (
    <AmountTable hideOnEmpty={props.hideOnEmpty ?? true} {...props}>
      {loanArray?.sort((a, b) => a.name.localeCompare(b.name)).map((loan) => children?.({ loan }))}
    </AmountTable>
  );
};
